export default "__VITE_ASSET__BCXzFqPW__"